import {Selectors} from '../Settings';

/**
 * Shortcuts
 */
export default class Shortcuts {
    constructor($shortcuts) {
        this.$shortcuts = $shortcuts;

        this.bindHandlers();
        this.adjustFooterPadding();
    }

    bindHandlers() {
        $('window').on('resize', () => {
            this.adjustFooterPadding();
        });
    }

    getHeight() {
        return this.$shortcuts.outerHeight();
    }

    adjustFooterPadding() {
        $('#footer').css('padding-bottom', this.getHeight());
    }
}